import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, DOCUMENT } from '@angular/common';

declare global {
    interface Window { dataLayer?: any[]; }
}

@Injectable({ providedIn: 'root' })
export class GtmService {
    private loaded = false;

    constructor(
        @Inject(DOCUMENT) private doc: Document,
        @Inject(PLATFORM_ID) private platformId: object
    ) {}

    load(containerId: string, dataLayerName = 'dataLayer'): void {
        if (!isPlatformBrowser(this.platformId)) return;
        if (this.loaded) return;
        if (!containerId) return;

        const w = window as any;
        w[dataLayerName] = w[dataLayerName] || [];
        w[dataLayerName].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

        // Head script (gtm.js)
        const script = this.doc.createElement('script');
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(containerId)}${
            dataLayerName !== 'dataLayer' ? `&l=${encodeURIComponent(dataLayerName)}` : ''
        }`;
        this.doc.head.appendChild(script);

        // Optional: noscript iframe (meaningful mostly for no-JS users, which… is not your SPA audience)
        const noscript = this.doc.createElement('noscript');
        const iframe = this.doc.createElement('iframe');
        iframe.src = `https://www.googletagmanager.com/ns.html?id=${encodeURIComponent(containerId)}`;
        iframe.height = '0';
        iframe.width = '0';
        iframe.style.display = 'none';
        iframe.style.visibility = 'hidden';
        noscript.appendChild(iframe);

        this.doc.body.prepend(noscript);

        this.loaded = true;
    }

    push(event: Record<string, any>, dataLayerName = 'dataLayer'): void {
        if (!isPlatformBrowser(this.platformId)) return;
        (window as any)[dataLayerName] = (window as any)[dataLayerName] || [];
        (window as any)[dataLayerName].push(event);
    }
}
